module.exports = __webpack_public_path__ + "youhui4.png?19ad8366303bfdab444db77b0c51d95e";


//////////////////
// WEBPACK FOOTER
// ./static/assets/youhui4.png
// module id = 189
// module chunks = 0